"use strict";

// ==================== Disclosures ============================================================
// An invisible checkbox or radio button that allows controling visibility without javascript
// See helpers.css for more info

// why not use details/summary everywhere?
//  - because NVDA can't handle links inside summary (used for treeview)
//  - summary (trigger) needs to be direct preceding sibling of content, this is too restrictive
//  - while summary can be inline in collapsed mode, the whole details is block mode when expanded
//  - it's not possible to overrule details with css, must use js (for example with different media queries, for printing, or editing in sitecore)
//  - do we need to force details open in Sitecore?
//  - note: hidden=until-found is default for details/summary (but can not be override with content-visibility:visible)

// TODO: use "popover" attribute where it makes sense (all elements that should close with Esc?) (Ch 114, Fx 125, Op 100, Sa 17)
//	 notes:
//	 - popovers can only be positioned absolutely, they can not be part of document flow
//	 - popover requires a button as trigger, while our disclosures require a label
//	 - there can be only one open "auto popover" on a page (logical, as the backdrop covers the whole page)
//	 - :popover-open CSS selector breaks the whole selector on older browsers, so any rules must be repeated in two separate blocks// TODO: user details/summary where it makes sense (accordions)
// TODO: user details/summary where it makes sense (accordions)
// TODO: support reset button (backdrop)
// TODO: check design guidelines, like 
//   https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html
//   http://designsystem/komponenter/accordion
// BUG: the same accordion element can be inserted multiple times in one page (using Sitecore); they get duplicate IDs, and only first one will open/close on click
// BUG: when displaying find results (using hidden=until-found), all elements with finds are open
//   this is problematic in some case, eg tabbars where all tabs are opened
//   use beforematch event to reset hidden attribute for all other elements
// BUG: Chrome 119 removes the hidden attribute when showing search results, but does NOT add it again when continuing search, eg when searching "abc" any hidden element containing "a" is unhidden, but not hidden again if the text is not "abc"
//   this causes problems when the shown element is positioned absolutely (over other content)
//   either these elements should not position absolutely when unhiding on find, or they should not allow opening on find
//   Note also: when a disclosure is opened through find, then it's aria-expanded is not set accordingly!
// TODO: aria-controls is allowed to point to multiple elements! (ie, show/hide multiple elements with one trigger)
// TODO: prevent trigger from scrolling up when item before is being closed
// TODO: can we just remove aria-expanded instead of setting it to false?

// Data structure:
// <input type="checkbox|radio" class="dcl-status" id="(status-id)" [data-controls="(content-id)"]/>
// <element class="dcl-content" [id="content-id"]>(Content display is controlled by CSS)</element>
// somewhere else: <label for="(status-id)" class="dcl-trigger">...</label>
// each status MUST have another parent, there can't be multiple as siblings
// data-controls is only required if content element is not sibling of status

/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
if (!document.querySelector("body").classList.contains("isEditing")) {

	let documentclasslist = document.documentElement.classList;
	let elms;

	// use a function that we can call directly instead of using an async event handler (to avoid animations during initial loading)
	// TODO: do these functions need to be global? because now they are (also means that names are not compressed)
	function setDisclosure(elm,setOpen) {
		if (setOpen) {
			elm.removeAttribute("hidden");
			elm.classList.add("dcl-open"); // use .dcl-open to distinguish between manually opened or opened by find
		} else {
			elm.setAttribute("hidden", "until-found");
			elm.classList.remove("dcl-open");
		}
		let elms = document.querySelectorAll(`[aria-controls='${elm.id}']`); // find all triggers for this element
		for (let trigger of elms) {
			trigger.setAttribute("aria-expanded", (setOpen == true));
		}
	}

	// click the trigger button
	function activateTrigger(elm) {
		if (elm.dataset.group) {
			const groupTriggers = document.querySelectorAll(`.dcl-trigger[data-group='${elm.dataset.group}'][aria-expanded='true']`);
			for (let trigger of groupTriggers) {
				setDisclosure(document.getElementById(trigger.getAttribute("aria-controls"))) // close all groupitems
			}
		}
		setDisclosure(document.getElementById(elm.getAttribute("aria-controls")), elm.getAttribute("aria-expanded") != "true")
	}

	// add page class to disable distracting animations
	documentclasslist.add("dcl-loading");
	elms = document.querySelectorAll(".dcl-status");
	for (let statusElm of elms) {

		// check status element
		if (statusElm.id == "") {
			console.warn("Could not find id for", statusElm);
			continue;
		}

		// find content element
		// use data-controls if the content element is not a sibling of the status element (rare)
		// find content either by id or by finding the first content-type element
		let contentElm =
			document.getElementById(statusElm.dataset.controls) /* content is defined by <label data-controls=...> */
			|| document.querySelector(`#${statusElm.id} ~ .dcl-content[data-value='${statusElm.value}']`) /* content is sibling defined by <xxx clas='dcl-content' data-value='???'> */
			|| document.querySelector(`#${statusElm.id} ~ .dcl-content`); /* content is first .dcl-content sibling */
		// we need an id, so create one if not available
		if (contentElm)
			contentElm.id = contentElm.id || self.crypto.randomUUID();

		// if Siteimprove is crawling site, then don't create JS functionality (as SiteImprove viewer does not execute JS)
		// TODO: can we use @media (scripting: initial-only) ?
		if (window.navigator.userAgent.includes("SiteCheck-sitecrawl")) {
			if (!contentElm.classList.contains("nav-popup")) {
				statusElm.setAttribute("checked","checked"); // setAttribute instead of just statusElm.checked, as we need to update the HTML itself for Siteimprove to capture
			}
			continue;
		}

		// convert input & label to button with aria, and set opened/closed status
		let triggerLabels = document.querySelectorAll(`.dcl-trigger[for=${statusElm.id}]`); /* there may be multiple triggers for each status */
		for (let triggerLabel of triggerLabels) {
			// create button
			let triggerButton = document.createElement("button");
			// transfer all attributes (except "for") from label to button
			for (let attr of triggerLabel.attributes) {
				triggerButton.setAttribute(attr.name, attr.value);
			}
			// set aria-controls
			if (contentElm)
				triggerButton.setAttribute("aria-controls",contentElm.id);
			// finalize button attributes
			triggerButton.removeAttribute("for"); // transferred from label
			triggerButton.type = "button"; // this prevents submit if inside form
			triggerButton.addEventListener("click",function(evt){
				activateTrigger(evt.currentTarget);
			})
			if (statusElm.getAttribute("name"))
				triggerButton.dataset.group = statusElm.getAttribute("name"); // status checkbox is part of a group (eg accordion group)
			
			// move the contents of the trigger to the button
			triggerButton.append(...triggerLabel.childNodes);
			// replace the trigger with the button
			triggerLabel.parentElement.insertBefore(triggerButton,triggerLabel);
			triggerLabel.parentElement.removeChild(triggerLabel);
		}

		// set status of contents and trigger
		let checked = statusElm.checked;
		if (contentElm)
			setDisclosure(contentElm,checked)

		// remove the old status element
		statusElm.parentElement.removeChild(statusElm);
	}

	// open the accordion targeted by a #<shortid> link: a one-time activateTrigger() call (the same path a
	// manual click takes), not a persistent style override - so it can still be closed normally afterward
	function openTargetFromHash(hash) {
		hash = hash || location.hash;
		let target = hash && document.getElementById(hash.slice(1));
		let trigger = target && target.querySelector(".dcl-trigger");
		if (!trigger) return;
		if (trigger.getAttribute("aria-expanded") === "false") activateTrigger(trigger);
	}
	openTargetFromHash();
	// fires on any hash change, but is mainly needed for browser back/forward, which doesn't reload the page or fire a click
	window.addEventListener("hashchange", () => openTargetFromHash());
	// handle situation where user closes the accordion and re-try the anchor. It will now open again.
	document.addEventListener("click", function(evt) {
		let link = evt.target.closest("a[href*='#']");
		if (!link) return;
		let url = new URL(link.getAttribute("href"), location.href);
		if (url.origin === location.origin && url.pathname === location.pathname && url.hash)
			openTargetFromHash(url.hash);
	});

	// convert all popover functionality for older browsers
	const supportsPopover = Object.hasOwn(HTMLElement.prototype, "popover") ? true : false;
	if (!supportsPopover) {
		elms = document.querySelectorAll("[popover]");
		for (let contentElm of elms) {
			contentElm.classList.add("dcl-content");
			let triggerButtons = document.querySelectorAll(`[popovertarget=${contentElm.id}]`)
			for (let triggerButton of triggerButtons) {
				triggerButton.setAttribute("aria-controls",contentElm.id);
				triggerButton.addEventListener("click",function(evt){
					activateTrigger(evt.currentTarget);
				})
			}
			setDisclosure(contentElm,false);
		}
	}

	documentclasslist.remove("dcl-loading");
}
